import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import RevisionNumber from 'utils/components/RevisionNumber/RevisionNumber';
import 'utils/components/RevisionNumber/RevisionNumber.scss';
import RevisionLabel from '../RevisionLabel';
import { NavigationProps } from '../Navigation';
import './ButtonNavigation.scss';

export const ODD_NUMBERED_COUNT = 5;

export default function ButtonNavigation(props: NavigationProps) {
    const {
        listIndex,
        endIndex,
        dispatchSetListIndexAction,
        dispatchIncrementListIndexAction,
        dispatchDecrementListIndexAction,
    } = props;

    const backDisable = listIndex === 0;
    const forwardDisable = listIndex === endIndex;

    const remainingIndices = ODD_NUMBERED_COUNT - 1;
    const centralStartIndex = listIndex - remainingIndices / 2;
    const isBelowZero = centralStartIndex < 0;
    const isGreaterThanEnd = listIndex + remainingIndices / 2 > endIndex;

    const startIndex =
        backDisable || isBelowZero
            ? 0
            : forwardDisable || isGreaterThanEnd
            ? endIndex - remainingIndices
            : centralStartIndex;

    const revisions = Array.from(new Array(ODD_NUMBERED_COUNT)).map((x, i) => (
        <RevisionNumber
            key={i}
            valIndex={startIndex + i}
            listIndex={listIndex}
            setIndex={dispatchSetListIndexAction}
        />
    ));

    const backOnClick = () => dispatchDecrementListIndexAction();
    const forwardOnClick = () => dispatchIncrementListIndexAction();

    return (
        <div className="ButtonNavigation">
            <RevisionLabel endIndex={endIndex} />
            <Icon
                className="RevisionNumber backButton"
                name="angle left"
                size="small"
                disabled={backDisable}
                onClick={backOnClick}
            />
            {revisions}
            <Icon
                className="RevisionNumber forwardButton"
                name="angle right"
                size="small"
                disabled={forwardDisable}
                onClick={forwardOnClick}
            />
        </div>
    );
}
